import { Page } from '@bonanza-social/navigation';
import { Navigate, useParams } from 'react-router';
import CategoryDetails from '../components/CategoryDetails/CategoryDetails';
import { State, useSelector } from '@bonanza-social/toolkit/state';
import {
  selectCategory,
  selectCategoriesState,
} from '../state/categories/categories.slice';
import useGames from '../hooks/useGames';

function CategoryDetailsPage() {
  const params = useParams();
  const categoriesState = useSelector(selectCategoriesState);
  const category = useSelector((state: State) =>
    selectCategory(state, params.categorySlug || ''),
  );

  useGames();

  if (!category && categoriesState === 'fulfilled') {
    return <Navigate to="/play-with-coins" replace />;
  }

  return (
    <Page
      title={category?.seoDetails?.title}
      description={category?.seoDetails?.description}
    >
      <CategoryDetails id={category?.id || -1} />
    </Page>
  );
}

export default CategoryDetailsPage;
